import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFloat = () => {
 const whatsappService = () => {
   const whatsappLink = "https://wa.link/g8i9xa";
   window.open(whatsappLink, '_blank');
 };

 return (
   <div className="whatsapp-float-container">
     <div className="whatsapp-float" onClick={whatsappService}>
       <div className="whatsapp-icon">
         <FaWhatsapp />
       </div>
       <span className="support-text">Support</span>
     </div>

     <style jsx>{`
       .whatsapp-float-container {
         position: fixed;
         bottom: 100px;
         right: 20px;
         z-index: 1000;
         font-family: 'Inter', system-ui, sans-serif;
       }

       .whatsapp-float {
         display: flex;
         flex-direction: column;
         align-items: center;
         gap: 6px;
         cursor: pointer;
         transition: transform 0.3s ease;
       }
       
       .whatsapp-float:hover {
         transform: translateY(-2px);
       }

       .whatsapp-icon {
         background: #25d366;
         color: white;
         border-radius: 50%;
         width: 50px;
         height: 50px;
         display: flex;
         align-items: center;
         justify-content: center;
         font-size: 24px;
         box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
         transition: all 0.3s ease;
       }
       
       .whatsapp-float:hover .whatsapp-icon {
         box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
         transform: scale(1.05);
       }

       .support-text {
         color: white;
         font-size: 11px;
         font-weight: 600;
         background: rgba(23, 42, 69, 0.9);
         border: 1px solid rgba(231, 76, 60, 0.2);
         padding: 4px 8px;
         border-radius: 12px;
         text-align: center;
         transition: all 0.3s ease;
       }
       
       .whatsapp-float:hover .support-text {
         background: rgba(23, 42, 69, 0.95);
         border-color: rgba(231, 76, 60, 0.4);
         color: #e74c3c;
       }

       /* Mobile responsiveness */
       @media (max-width: 768px) {
         .whatsapp-float-container {
           bottom: 90px;
           right: 16px;
         }
         
         .whatsapp-icon {
           width: 46px;
           height: 46px;
           font-size: 22px;
         }
         
         .support-text {
           font-size: 10px;
           padding: 3px 6px;
         }
       }
       
       @media (max-width: 480px) {
         .whatsapp-float-container {
           bottom: 85px;
           right: 12px;
         }
         
         .whatsapp-icon {
           width: 42px;
           height: 42px;
           font-size: 20px;
         }
         
         .support-text {
           font-size: 9px;
           padding: 2px 5px;
         }
       }
     `}</style>
   </div>
 );
};

export default WhatsAppFloat;
